export default __webpack_public_path__ + "static/media/buy_now_1.415d4e6d.jpg";